import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/zoom.vue
var s = {
	name: "DtIconZoom",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["fill"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--zoom"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Zoom",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [
		i("rect", {
			x: "2",
			y: "2",
			width: "20",
			height: "20",
			rx: "6",
			fill: `url(#${e.uniqueID}a)`
		}, null, 8, l),
		t[1] || (t[1] = i("path", {
			d: "M7 8.563a.625.625 0 0 0-.625.624v4.027c0 1.036.84 1.875 1.875 1.875h5.807c.345 0 .625-.28.625-.625v-4.027c0-1.035-.84-1.874-1.875-1.874H7Zm8.495 1.622a.625.625 0 0 0-.22.476v2.627c0 .183.08.357.22.476l1.568 1.337a.625.625 0 0 0 1.03-.476V9.323a.625.625 0 0 0-1.03-.475l-1.568 1.337Z",
			fill: "#fff"
		}, null, -1)),
		i("defs", null, [i("linearGradient", {
			id: `${e.uniqueID}a`,
			x1: "12",
			y1: "2",
			x2: "12",
			y2: "22",
			gradientUnits: "userSpaceOnUse"
		}, [...t[0] || (t[0] = [
			i("stop", { "stop-color": "#4594FF" }, null, -1),
			i("stop", {
				offset: ".604",
				"stop-color": "#357CFC"
			}, null, -1),
			i("stop", {
				offset: "1",
				"stop-color": "#2C6FFA"
			}, null, -1)
		])], 8, u)])
	], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=zoom.js.map